import { render, staticRenderFns } from "./TextFileIcon.vue?vue&type=template&id=1012f168&"
import script from "./TextFileIcon.vue?vue&type=script&lang=ts&"
export * from "./TextFileIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports